import {outter_post,post} from 'common/js/axios-helper';
import {OrganApi} from "./constant/UrlMapper";




const host = '8880';
const host2 = '8885';
const host3="8883"
const list = (data) => {
    return outter_post(OrganApi.List, data, host);
};

const addQpayInfo = (data) => {
    return outter_post('/qpayInfo/qpay-info/addQpayInfo', data, host2);
};


const update = (data) => {
    return outter_post(OrganApi.Update, data, host);
};

const add = (data) => {
    return outter_post(OrganApi.Add, data, host);
};

const prohibit = (data) => {
    return outter_post(OrganApi.Prohibit, data, host);
};

const simpleNames = (data) => {
    return outter_post(OrganApi.SimpleNames, data, host);
};

const detail = (data) => {
    return outter_post(OrganApi.Detail, data, host);
};

const abbrs = (data) => {
    return outter_post(OrganApi.Abbrs, data, host);
};

const getMems = (data) => {
    return outter_post(OrganApi.GetMems, data, host);
};

const privateMemMerchantList = (data) => {
    return outter_post(OrganApi.privateMemMerchantList, data, host3);
};

const privateMemList = (data) => {
    return outter_post(OrganApi.privateMemList, data, host3);
};

const privateMemudpStatus = (data) => {
    return outter_post(OrganApi.privateMemudpStatus, data, host3);
};

const privateMemMerchantDel = (data) => {
    return outter_post(OrganApi.privateMemMerchantDel, data, host3);
};
const organuserInsert = (data) => {
    return outter_post(OrganApi.OrganUserInsert, data, host3);
};

const getTatAndApps = (data) => {
    return outter_post(OrganApi.GetTatAndApps, data, host);
};

const selectOne = (data) => {
    return outter_post(OrganApi.SelectOne, data, host3);
};

const blackAdd = (data) => {
    return outter_post(OrganApi.BlackAdd, data, host3);
};

const blackList = (data) => {
    return outter_post(OrganApi.BlackList, data, host3);
};

const blackOut = (data) => {
    return outter_post(OrganApi.BlackOut, data, host3);
};

const blackUpdate = (data) => {
    return outter_post(OrganApi.BlackUpdate, data, host3);
};

const rebateLogInfo = (data) => {
    return outter_post(OrganApi.RebateLogInfo, data, host3);
};

const rebateLogInfoAdd = (data) => {
    return outter_post(OrganApi.RebateLogInfoAdd, data, host3);
};

const accountsuperviseList = (data) => {
    return outter_post(OrganApi.AccountSuperviseList, data, host3);
};
const AccountTopList = (data) => {
    return outter_post(OrganApi.AccountTopList, data, host3);
};
const AccountJiaoyi = (data) => {
    return outter_post(OrganApi.AccountJiaoyi, data, host3);
};
const accountsuperviseListNew = (data) => {
    return outter_post(OrganApi.AccountSuperviseListNew, data, host3);
};
const accountsuperviseEdit = (data) => {
    return outter_post(OrganApi.AccountSuperviseEdit, data, host3);
};
//----------------------用户管理模块
//商户详情接口
const merchantInfoList = (data) => {
    return outter_post(OrganApi.MerchantInfoList, data, host3);
};
const merchantInfoHB = (data) => {
    return outter_post(OrganApi.MerchantInfoHB, data, host2);
};
const merchantInfoEdit = (data) => {
    return outter_post(OrganApi.MerchantInfoEdit, data, host3);
};
const merchantInfoZx = (data) => {
    return outter_post(OrganApi.MerchantInfoZx, data, host2);
};
const merchantInfoup = (data) => {
    return outter_post(OrganApi.MerchantInfoUp, data, host3);
};
const merchantinfoStatus = (data) => {
    return outter_post(OrganApi.MerchantInfoStatus, data, host3);
};
const copymerchantInfoFeilvFeilv = (data) => {
    return outter_post(OrganApi.CopyMerchantInfoManageFeilv, data, host2);
};
const newGengxin= (data) => {
    return post(OrganApi.newGengxin, data, host2);
};
const copymerchantInfoManageList = (data) => {
    return outter_post(OrganApi.CopyMerchantInfoManageList, data, host2);
};
const copymerchantInfoManageInsert = (data) => {
    return outter_post(OrganApi.CopyMerchantInfoManageInsert, data, host2);
};
const copymerchantInfoManageEdit = (data) => {
    return outter_post(OrganApi.CopyMerchantInfoManageEdit, data, host2);
};
const copymerchantInfoManageDel = (data) => {
    return outter_post(OrganApi.CopyMerchantInfoManageDel, data, host2);
};

//代理商等级接口
const memberupgradeList = (data) => {
    return outter_post(OrganApi.MemberupgradeList, data, host3);
};
const memberupgradeEdit = (data) => {
    return outter_post(OrganApi.MemberupgradeEdit, data, host3);
};
const memberupgradeInsert = (data) => {
    return outter_post(OrganApi.MemberupgradeInsert, data, host3);
};
const memberupgradeDel = (data) => {
    return outter_post(OrganApi.MemberupgradeDel, data, host3);
};

//代理商升级查询
const getMemUps = (data) => {
    return outter_post(OrganApi.GetMemUps, data, host2);
};

//合伙人升级配置及明细
const partnerlevelmanageList = (data) => {
    return outter_post(OrganApi.PartnerLevelManageList, data, host2);
};
const partnerlevelmanageUpdate = (data) => {
    return outter_post(OrganApi.PartnerLevelManageUpdate, data, host2);
};
const partnerlookinfoList = (data) => {
    return outter_post(OrganApi.PartnerLookInfoList, data, host2);
};
const partnerlevelinfoList = (data) => {
    return outter_post(OrganApi.PartnerLevelInfoList, data, host2);
};

//升级考核
const upgradeassessmentList = (data) => {
    return outter_post(OrganApi.UpgradeassessmentList, data, host2);
};
const upgradeassessmentSave = (data) => {
    return outter_post(OrganApi.UpgradeassessmentSave, data, host2);
};

const agentperformanceList = (data) => {
    return outter_post(OrganApi.AgentPerformanceList, data, host2);
};
const agentperformanceHj = (data) => {
    return outter_post(OrganApi.AgentPerformanceHj, data, host2);
};
const agentperformancedetailsList = (data) => {
    return outter_post(OrganApi.AgentPerformanceDetailsList, data, host2);
};

//身份配置
const identitymanageList = (data) => {
    return outter_post(OrganApi.IdentityManageList, data, "9000");
};
const identitymanageUpdate = (data) => {
    return outter_post(OrganApi.IdentityManageUpdate, data, "9000");
};

//商户评价
const merchantevaluationList = (data) => {
    return outter_post(OrganApi.MerchantEvaluationList, data, host2);
};
const merchantevaluationAdd = (data) => {
    return outter_post(OrganApi.MerchantEvaluationAdd, data, host2);
};

//云闪付商户
const cloudflashpaymentList = (data) => {
    return outter_post(OrganApi.CloudFlashPaymentList, data, host2);
};
//----------------------用户管理模块


export default {
    list,
    addQpayInfo,
    update,
    add,
    prohibit,
    simpleNames,
    detail,
    abbrs,
    getMems,
    privateMemList,
    privateMemMerchantList,
    privateMemudpStatus,
    privateMemMerchantDel,
    organuserInsert,
    getTatAndApps,
    selectOne,
    blackAdd,
    blackList,
    blackOut,
    blackUpdate,
    rebateLogInfo,
    rebateLogInfoAdd,
    accountsuperviseList,
    accountsuperviseEdit,

    merchantInfoList,
    merchantInfoEdit,
    merchantInfoHB,
    merchantInfoZx,
    merchantInfoup,
    merchantinfoStatus,
    copymerchantInfoFeilvFeilv,
    copymerchantInfoManageList,
    copymerchantInfoManageInsert,
    copymerchantInfoManageEdit,
    copymerchantInfoManageDel,

    memberupgradeList,
    memberupgradeEdit,
    memberupgradeInsert,
    memberupgradeDel,

    getMemUps,

    partnerlevelmanageList,
    partnerlevelmanageUpdate,
    partnerlookinfoList,
    partnerlevelinfoList,

    upgradeassessmentList,
    upgradeassessmentSave,

    agentperformanceList,
    agentperformanceHj,
    agentperformancedetailsList,

    identitymanageList,
    identitymanageUpdate,

    merchantevaluationList,
    merchantevaluationAdd,

    cloudflashpaymentList,
    accountsuperviseListNew,
    AccountTopList,
    AccountJiaoyi,
    newGengxin
}



// WEBPACK FOOTER //
// ./src/service/OrganService.js